import { render, staticRenderFns } from "./invoice-fill.vue?vue&type=template&id=223138a4"
import script from "./invoice-fill.vue?vue&type=script&lang=js"
export * from "./invoice-fill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports